import type { ObjectId, WithId } from 'mongodb';

import type { Locale } from './index';

export enum DisclosureType {
  creditApplication = 'creditApplication',
  prequalification = 'prequalification',
  txtMessageNotifications = 'txtMessageNotifications',
  termsAndConditions = 'termsAndConditions',
  congaSigningConsent = 'congaSigningConsent',
}

export interface DisclosureDefinition {
  id?: string | ObjectId;
  name: string;
  type: DisclosureType;
  effectiveDate: Date;
  brand?: string; //TODO: not sure if I like this yet, but here as a placeholder until I have a better idea of what account attributes to filter on
  version: string;
  versionNumber: number;
  summary: string;
  text: string;
  requireConsent: boolean;
  acceptanceLabel: string;
  language: Locale;
}

export type DisclosureDocument = WithId<DisclosureDefinition>;
